function intersectNode (node, point) {
  return node.intersect(point)
}

export default intersectNode



// WEBPACK FOOTER //
// ./lib/intersect/intersect-node.js